import { useState } from 'react'

import { httpStatuses } from '@reveni-io/reveni-ui'

const useHandleCreateReturnErrors = ({ setContext }) => {
  const [showExchangeNotAllowedModal, setShowExchangeNotAllowedModal] = useState(false)
  const [showReturnShippedErrorModal, setShowReturnShippedErrorModal] = useState(false)

  const openExchangeNotAllowedModal = () => {
    setShowExchangeNotAllowedModal(true)
  }

  const closeExchangeNotAllowedModal = () => {
    setShowExchangeNotAllowedModal(false)
  }

  const openReturnShippedErrorModal = () => {
    setShowReturnShippedErrorModal(true)
  }

  const closeReturnShippedErrorModal = cb => {
    setShowReturnShippedErrorModal(false)
    if (cb) cb()
  }

  const handleErrors = error => {
    if (error?.response?.status === httpStatuses.forbidden) {
      openExchangeNotAllowedModal()
    }

    if (error?.response?.status === httpStatuses.badRequest && error?.response?.data?.join_group) {
      setContext(context => ({ ...context, orderInfo: { ...context.orderInfo, joinGroup: false } }))
      openReturnShippedErrorModal()
    }
  }

  return {
    openExchangeNotAllowedModal,
    openReturnShippedErrorModal,
    showExchangeNotAllowedModal,
    closeExchangeNotAllowedModal,
    showReturnShippedErrorModal,
    closeReturnShippedErrorModal,
    handleErrors,
  }
}

export default useHandleCreateReturnErrors
